/**
 * Para el caso de estás URLs se carga otro script, por ende, se evita cargar el script principal para evitar conflictos
 */

const URLsToNotLoadBundle = [
  'https://www.allianz.es/forms/tellamamos-w.html',
  'https://www.allianz.es/forms/l/tellamamos-w.html',
  'https://www.allianz.es/forms/tellamamos.html',
  'https://www.allianz.es/forms/l/tellamamos.html'
]

export function isFormLanding() {
  const urlPath = window.location.pathname

  if (urlPath === '/') return false

  return URLsToNotLoadBundle.some((link) => {
    return link.includes(urlPath)
  })
}
